import { useState } from "react";
import SEO from "../components/SEO";
import { Reveal, LineReveal } from "../components/Reveal";
import { StoryCard } from "../components/cards";
import { getStories } from "../lib/content";

const filters = [
  { key: "all", label: "All" },
  { key: "from-pilcoo", label: "From PilCoo" },
  { key: "animals", label: "Animals" },
  { key: "people", label: "People" },
  { key: "nature", label: "Nature" },
  { key: "perspective", label: "Perspective" },
  { key: "community", label: "Community" },
];

export default function Stories() {
  const [active, setActive] = useState("all");
  const all = getStories();
  const visible = active === "all" ? all : all.filter((s) => s.category === active);

  return (
    <main>
      <SEO
        title="Stories"
        description="Reflections, education and community stories from PilCoo — across animals, people, nature and community."
        path="/stories"
      />
      <section className="pt-32 md:pt-44 pb-12 md:pb-16" data-testid="stories-header">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <p className="text-xs uppercase tracking-[0.25em] font-medium text-ink-2">Stories</p>
          <h1 className="mt-6 font-serif tracking-tighter leading-[0.98] text-ink text-5xl sm:text-6xl lg:text-7xl">
            <LineReveal lines={["Stories from PilCoo"]} delay={0.15} />
          </h1>
          <Reveal delay={0.4}>
            <p className="mt-8 max-w-2xl text-base md:text-lg leading-relaxed text-ink-2">
              Ideas, field notes and stories about compassion in action — across
              animals, people and nature.
            </p>
          </Reveal>

          <Reveal delay={0.5}>
            <div className="mt-10 flex flex-wrap gap-2" role="group" aria-label="Filter stories by category">
              {filters.map((f) => (
                <button
                  key={f.key}
                  type="button"
                  onClick={() => setActive(f.key)}
                  aria-pressed={active === f.key}
                  data-testid={`stories-filter-${f.key}`}
                  className={`rounded-full px-5 py-2.5 text-sm font-semibold transition-colors duration-300 ${
                    active === f.key
                      ? "bg-ink text-sand"
                      : "border border-line text-ink-2 hover:text-ink hover:border-ink"
                  }`}
                >
                  {f.label}
                </button>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      <section className="pb-24 md:pb-32" data-testid="stories-grid">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          {visible.length === 0 ? (
            <p className="py-16 text-center text-ink-2" data-testid="stories-empty">
              No stories in this category yet — they're being written.
            </p>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-14">
              {visible.map((story, i) => (
                <Reveal key={story.slug} delay={i * 0.06}>
                  <StoryCard story={story} withImage />
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>
    </main>
  );
}
